export const removeV1 = (value: string) => {
  if (value.includes('v1')) {
    value = value.split('-')[0]
  }
  return value
}
